import { ButtonLink, EmptyState } from '../design-system/index.ts';

export function NotFoundPage() {
  return (
    <EmptyState title="Cette page n’existe pas" action={<ButtonLink to="/">Retour à l’accueil</ButtonLink>}>
      Le lien est peut-être ancien, ou le projet a été supprimé.
    </EmptyState>
  );
}
